<template>
  <template v-if="workspaceUsage">
    <nuxt-link
      v-if="workspaceUsage.user_can_manage_subscription"
      :to="changePlanRoute"
      class="saas-all-workspaces-plan-badge-link"
    >
      <DashboardWorkspacePlanBadge
        :workspace="workspace"
        :component-arguments="componentArguments"
        size="small"
      ></DashboardWorkspacePlanBadge>
    </nuxt-link>
    <DashboardWorkspacePlanBadge
      v-else
      :workspace="workspace"
      :component-arguments="componentArguments"
      size="small"
    ></DashboardWorkspacePlanBadge>
  </template>
</template>

<script>
import DashboardWorkspacePlanBadge from '@saas/components/dashboard/DashboardWorkspacePlanBadge'
import { getChangePlanRoute } from '@saas/utils/subscription'

export default {
  name: 'AllWorkspacesWorkspacePlanBadge',
  components: { DashboardWorkspacePlanBadge },
  props: {
    workspace: {
      type: Object,
      required: true,
    },
    componentArguments: {
      type: Object,
      required: true,
    },
  },
  computed: {
    // The usage isn't there while it's being fetched, or for a workspace that
    // was created after it was fetched.
    workspaceUsage() {
      return (this.componentArguments.usageData ?? []).find(
        (u) => u.workspace_id === this.workspace.id
      )
    },
    changePlanRoute() {
      return getChangePlanRoute(this.workspaceUsage)
    },
  },
}
</script>
